import {
  IsBoolean,
  IsEnum,
  IsOptional,
  IsString,
  IsUUID,
} from 'class-validator'
import { ApiPropertyOptional } from '@nestjs/swagger'
import { ExportFormat } from '../../interfaces/export'

/**
 * Options communes pour les exports
 */
export class BaseExportQueryDto {
  @ApiPropertyOptional({
    description: 'Format de l\'export',
    enum: ExportFormat,
    default: ExportFormat.XLSX,
  })
  @IsOptional()
  @IsEnum(ExportFormat)
  format?: ExportFormat = ExportFormat.XLSX
}

/**
 * Options d'export pour un enseignement
 */
export class TeachingExportQueryDto extends BaseExportQueryDto {
  @ApiPropertyOptional({ type: Boolean, description: 'Inclure les chapitres', default: true })
  @IsOptional()
  @IsBoolean()
  includeChapters?: boolean = true

  @ApiPropertyOptional({ type: Boolean, description: 'Inclure les leçons', default: true })
  @IsOptional()
  @IsBoolean()
  includeLessons?: boolean = true

  @ApiPropertyOptional({ type: Boolean, description: 'Inclure les ressources', default: false })
  @IsOptional()
  @IsBoolean()
  includeResources?: boolean = false

  @ApiPropertyOptional({ type: Boolean, description: 'Inclure les enseignants', default: true })
  @IsOptional()
  @IsBoolean()
  includeStaff?: boolean = true

  @ApiPropertyOptional({ type: Boolean, description: 'Inclure les étudiants', default: false })
  @IsOptional()
  @IsBoolean()
  includeStudents?: boolean = false
}

/**
 * Options d'export pour un établissement
 */
export class EstablishmentExportQueryDto extends BaseExportQueryDto {
  @ApiPropertyOptional({ type: 'string', description: 'ID de l\'année scolaire pour filtrer' })
  @IsOptional()
  @IsUUID('4')
  schoolYearId?: string

  @ApiPropertyOptional({ type: Boolean, description: 'Inclure les classes', default: true })
  @IsOptional()
  @IsBoolean()
  includeClasses?: boolean = true

  @ApiPropertyOptional({ type: Boolean, description: 'Inclure les enseignements', default: true })
  @IsOptional()
  @IsBoolean()
  includeTeachings?: boolean = true

  @ApiPropertyOptional({ type: Boolean, description: 'Inclure le personnel', default: false })
  @IsOptional()
  @IsBoolean()
  includeStaff?: boolean = false

  @ApiPropertyOptional({ type: Boolean, description: 'Inclure les étudiants', default: false })
  @IsOptional()
  @IsBoolean()
  includeStudents?: boolean = false

  @ApiPropertyOptional({ type: 'string', description: 'Code niveau pour filtrer (ex: 6e, 2de)' })
  @IsOptional()
  @IsString()
  levelCode?: string

  @ApiPropertyOptional({ type: 'string', description: 'Code matière pour filtrer (ex: MATH, FR)' })
  @IsOptional()
  @IsString()
  subjectCode?: string
}

/**
 * Options d'export pour le rapport de charge d'enseignement
 */
export class TeachingLoadExportQueryDto extends BaseExportQueryDto {
  @ApiPropertyOptional({ type: 'string', description: 'ID de l\'année scolaire' })
  @IsOptional()
  @IsUUID('4')
  schoolYearId?: string

  @ApiPropertyOptional({ type: 'string', description: 'Code niveau pour filtrer' })
  @IsOptional()
  @IsString()
  levelCode?: string

  @ApiPropertyOptional({ type: 'string', description: 'Code matière pour filtrer' })
  @IsOptional()
  @IsString()
  subjectCode?: string

  @ApiPropertyOptional({ type: 'string', description: 'ID d\'un enseignant spécifique' })
  @IsOptional()
  @IsString()
  teacherUserId?: string
}
